(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for agenda appointment time past modal 
    module.controller('AgendaAppointmentConfirmAppointmentSavePopupController',
        ['$uibModalInstance','appointmentType', AgendaAppointmentConfirmAppointmentSavePopupControllerFn]);

    function AgendaAppointmentConfirmAppointmentSavePopupControllerFn($uibModalInstance, appointmentType) {
        var vm = this;

        vm.appointmentType = appointmentType;
      
        // update appointment
        vm.save = function () {
            $uibModalInstance.close(true);
        };

        // book appointment ->  block = false
        vm.cancel = function () {
            $uibModalInstance.close(false);
        };

    }

})();